export const FINANCING_I4F_HOW_IT_WORKS_PATH = "/financing-i4f-how-it-works";

export const FINANCING_I4F_HOW_IT_WORKS_META = {
  title: "How Finance With Ideal4Finance Works | CRS Energy",
  description:
    "The step-by-step journey when you pay monthly through our finance partner Ideal4Finance, from application and ID checks to installation and sign-off.",
} as const;

export const FINANCING_I4F_JOURNEY_STEPS = [
  {
    title: "Apply Online",
    body: "You'll enter some general information about yourself and the loan amount you need, matching the amount on your written quote.",
  },
  {
    title: "Verify Your Identity",
    body: "The quickest route is open banking, which lets the lender confirm what it needs securely through your bank. Prefer not to use it? No problem. You may instead be asked for ID verification and some supporting documents.",
  },
  {
    title: "Supporting Documents (Sometimes)",
    body: "The lender may email you for extra documentation, such as bank statements, to complete their checks. Replying quickly keeps your application moving.",
  },
  {
    title: "Your Decision",
    body: "You'll be approved in principle, declined, or placed under review while the underwriters take a closer look.",
  },
  {
    title: "Agree Your Loan Terms",
    body: "If approved, you'll receive an email with a link to complete your purchase and agree the loan terms. This is where you choose your loan term and payment dates and set up your Direct Debit.",
  },
  {
    title: "Detailed Survey & Final Design",
    body: "With your agreement in place, we complete your detailed survey and final design - for solar, this is done from the desktop using aerial mapping, roof measurements, your energy usage and photos of your property. We'll only arrange a home visit if something needs a physical check, and we'll confirm your final design with you before anything is booked.",
  },
  {
    title: "We Schedule The Work",
    body: "Once your agreement is complete and any deposit is paid, we book your installation. Work can't start before this point. It's a condition of the finance.",
  },
  {
    title: "Installation",
    body: "Our accredited team completes the work as quoted.",
  },
  {
    title: "Sign-Off And A Quick Call",
    body: "When the work's done and you're happy, you sign a satisfaction note. Ideal4Finance will then give you a short call to confirm you're satisfied. It comes from a number beginning 01772, so it's worth saving or expecting that call. Once you've confirmed, everything is settled.",
  },
] as const;

export const FINANCING_I4F_FAQS = [
  {
    q: "Do I have to use open banking?",
    a: "No. It's the fastest route, but if you'd prefer not to, you may be asked for ID verification and some supporting documents instead.",
  },
  {
    q: "When can the work start?",
    a: "Once you've agreed your loan terms, set up your Direct Debit and paid any deposit that applies. It's a condition of the finance that work doesn't begin before then.",
  },
  {
    q: "What's the call from 01772 about?",
    a: "After you've signed your satisfaction note, Ideal4Finance calls to confirm you're happy with the completed work. It's a quick, friendly call, and answering it promptly wraps everything up.",
  },
  {
    q: "Do I have to take finance to use CRS Energy?",
    a: "No. Finance is a payment option, not a requirement, and there's never any obligation to apply.",
  },
  {
    q: "Will applying affect my credit score?",
    // CONFIRM SOFT/HARD SEARCH WORDING WITH I4F.
    a: "A credit check happens at the application stage with Ideal4Finance, not when you enquire with us. We'll make clear when you're at that stage.",
  },
] as const;
